<!-- src/components/StatementTab.vue -->
<template>
  <div>
    <!-- 操作按钮行 -->
    <div class="search-box">
      <div class="left">
        <div class="child">
          <DateSelect ref="dateSelect" @change="dateChange">对账日期：</DateSelect>
        </div>

        <div class="child">
          <span class="label">单据号：</span>
          <el-input
            v-model="searchParams.purchaseNo"
            style="width: 250px;"
            placeholder="请输入对账单号、业务单号、订单号"
            size="mini"
            clearable
          />
        </div>
        <div class="child">
          <span class="label">对账状态：</span>
          <el-select
            v-model="searchParams.statementStatus"
            placeholder="全部"
            style="width: 150px;"
            size="mini"
            clearable
          >
            <el-option label="全部" :value="0" />
            <el-option label="待支付" :value="2" />
            <el-option label="待对方支付" :value="3" />
            <el-option label="已完成" :value="4" />
          </el-select>
        </div>
        <div class="child">
          <span class="label">经办人：</span>
          <el-input
            v-model="searchParams.operator"
            style="width: 150px;"
            placeholder="请输入经办人"
            size="mini"
            clearable
          />
        </div>
        <div class="child" style="margin-left: 12px;">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button size="mini" @click="handleReset">重置</el-button>
        </div>
      </div>
      <!-- <el-button type="success" size="mini" @click="handleExport">导出</el-button> -->
    </div>
    <!-- 表格 -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        stripe
        @sort-change="sortChange"
        style="width:100%;"
        size="small"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column label="序号" width="60" type="index" align="center" fixed></el-table-column>
        <el-table-column label="操作" width="60" align="center" fixed>
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="toPlay(scope.row)" v-if="scope.row.statementStatus === '待支付'"
              >结算</el-button
            >
            <!-- <el-button type="text" size="mini" @click="handleView(scope.row)">打印</el-button>
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">导出</el-button>
            <el-button type="text" size="mini" style="color:#F56C6C;" @click="handleDelete(scope.row)">分享</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="statementStatus"
          label="对账状态"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <span :style="{ color: scope.row.statementStatus === '已完成' ? '#298fd9' : '#dd0d0d' }">{{
              scope.row.statementStatus
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseNo"
          label="对账单号"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <span @click="toDetails(scope.row)" class="link-txt">{{ scope.row.purchaseNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="arrear"
          label="应结款"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">{{ scope.row.arrear }}</template>
        </el-table-column>
        <el-table-column
          prop="settleCurr"
          label="已结款"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">{{ scope.row.settleCurr }}</template>
        </el-table-column>
        <el-table-column
          prop="discountAmount"
          label="优惠金额"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">{{ scope.row.discountAmount }}</template>
        </el-table-column>
        <el-table-column
          prop="noSettleCurr"
          label="未结款"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">{{ scope.row.noSettleCurr }}</template>
        </el-table-column>
        <el-table-column
          prop="statementPeriod"
          label="业务期间"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="200"
        />
        <el-table-column
          prop="billDate"
          label="对账日期"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="180"
        />
        <el-table-column
          prop="lastSettleDate"
          label="最后结算日期"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="170"
        />
        <el-table-column
          prop="preClearingDate"
          label="预结算日期"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="130"
        />
        <el-table-column
          prop="handler"
          label="经办人"
          show-overflow-tooltip
          sortable="custom"
          align="center"
          min-width="100"
        />
      </el-table>
    </div>

    <!-- 分页 -->
    <div style="margin-top:12px;text-align:right;">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="searchParams.pageSize"
        :current-page.sync="searchParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { statementList } from "@/api/reconciliation";
import DateSelect from "@/components/DateSelect";
const dateRange = window.tool.getDateRangeByName("本月");
export default {
  name: "StatementTab",
  components: {
    DateSelect
  },
  data() {
    return {
      searchParams: {
        purchaseNo: "", //单据号
        statementStatus: 0, //对账单状态 0全部/2待支付/3待对方支付/4结算完成
        operator: "", //操作人（经办、提交、确认、制单、对方对账）
        fromDate: dateRange[0], //业务开始日期
        toDate: dateRange[1], //业务结束日期
        sort: "", //排序字段
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      loading: false,
      totalInfo: {}
    };
  },
  methods: {
    dateChange(dateObj) {
      this.searchParams.fromDate = dateObj.startDate;
      this.searchParams.toDate = dateObj.endDate;
    },
    sortChange({ prop, order }) {
      if (order) {
        if (order.includes("desc")) {
          this.searchParams.sort = `${prop}-desc`;
        } else {
          this.searchParams.sort = `${prop}-asc`;
        }
      } else {
        this.searchParams.sort = "";
      }
      this.getList();
    },
    getList() {
      this.loading = true;
      statementList(this.searchParams)
        .then(res => {
          console.log("对账单列表", res);
          this.tableData = res.rows || [];
          this.total = res.totalSize;
          this.totalInfo = {
            arrear: res.sumArrear,
            settleCurr: res.sumSettleCurr,
            discountAmount: res.sumDiscountAmount,
            noSettleCurr: res.sumNoSettleCurr
          };
        })
        .catch(err => {
          this.tableData = [];
          this.total = 0;
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 合计行计算方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 需要对哪些列进行合计
        const sumFields = ["arrear", "settleCurr", "discountAmount", "noSettleCurr"];
        if (sumFields.includes(prop)) {
          sums[index] = this.totalInfo[prop]; // 保留两位小数
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    handleSearch() {
      this.searchParams.page = 1;
      this.getList();
    },
    handleReset() {
      this.searchParams = {
        purchaseNo: "", //单据号
        statementStatus: 0, //对账单状态 0全部/2待支付/3待对方支付/4结算完成
        operator: "", //操作人（经办、提交、确认、制单、对方对账）
        // fromDate: "", //业务开始日期
        // toDate: "", //业务结束日期
        sort: "", //排序字段
        page: 1,
        pageSize: this.searchParams.pageSize
      };
      this.$refs.dateSelect.reset();
      this.$refs.dateSelect.confirm();
      this.getList();
    },
    handleExport() {
      this.$message.success("导出对账单 (静态演示)");
    },
    toPlay(row) {
      console.log(row);
      let path = "";
      if (this.$route.path.includes("/new-products/system-center/wl-reconciliation")) {
        path = "/new-products/system-center/wl-reconciliation/pay";
      } else {
        path = "/reconciliations/statementPay";
      }
      this.$router.push({
        path: path,
        query: { id: row.purchaseID }
      });
    },
    toDetails(row) {
      console.log(row);
      let path = "";
      if (this.$route.path.includes("/new-products/system-center/wl-reconciliation")) {
        path = "/new-products/system-center/wl-reconciliation/statementDetails";
      } else {
        path = "/reconciliations/statementDetails";
      }
      this.$router.push({
        path: path,
        query: { id: row.purchaseID }
      });
    },
    handleView(row) {
      this.$message.info("查看对账单: " + row.code);
    },
    handleEdit(row) {
      this.$message.info("编辑对账单: " + row.code);
    },
    handleDelete(row) {
      this.$message.warning("删除对账单: " + row.code);
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    statusTag(type) {
      const map = { done: "已对账", pending: "待对账", wait: "部分对账", cancel: "作废" };
      return map[type] || type;
    },
    statusClass(type) {
      return "tag-status " + (type || "default");
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  box-sizing: border-box;
  background-color: rgba(249, 249, 249, 1);
  .left {
    display: flex;
    align-items: center;
    .child {
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        color: #555555;
        min-width: 80px;
        text-align: right;
      }
    }
  }
}
.link-txt {
  color: #628cff;
  cursor: pointer;
}
.table-wrap {
  margin-top: 4px;
  overflow-x: auto;
}
.table-wrap .el-table {
  font-size: 13px;
}
.tag-status {
  font-size: 12px;
  padding: 0 10px;
  border-radius: 12px;
  line-height: 24px;
  display: inline-block;
}
.tag-status.done {
  background: #e1f3d8;
  color: #67c23a;
}
.tag-status.pending {
  background: #fdf6ec;
  color: #e6a23c;
}
.tag-status.wait {
  background: #e9f0fc;
  color: #409eff;
}
.tag-status.cancel {
  background: #fef0f0;
  color: #f56c6c;
}
.tag-status.default {
  background: #f4f4f5;
  color: #909399;
}
</style>
